<div class="d-flex flex-row align-items-center checkbox-wrapper">
    <input
        type="checkbox"
        [formControl]="formController"
        (click)="onClick($event.target.checked)"
    />
    <span>{{ label }}</span>
</div>
